
import React from 'react';
import { Check } from 'lucide-react';

const ExperiencedJourney = () => {
  const journeySteps = [
    {
      title: "Teknisk forfining",
      description: "Vi arbejder med at forfine og perfektionere dine tekniske færdigheder til et højere niveau.",
      points: [
        "Avancerede fingerteknikker og øvelser",
        "Pedalteknik og klangstyring",
        "Håndtering af komplekse passager og figurationer",
        "Optimering af fingersætning for avancerede værker"
      ]
    },
    {
      title: "Musikalsk fortolkning",
      description: "Udvikling af din personlige musikalske stemme og fortolkningsevne.",
      points: [
        "Stilistisk indsigt i forskellige musikalske perioder",
        "Nuanceret frasering og artikulation",
        "Dynamisk kontrol og udtryksfuld klangbehandling",
        "Historisk kontekst og opførelsespraksis"
      ]
    },
    {
      title: "Repertoireudbygning",
      description: "Udvidelse af dit repertoire med udfordrende og varierede værker.",
      points: [
        "Analyse og indstudering af komplekse værker",
        "Balanceret repertoire på tværs af forskellige stilarter",
        "Forberedelse til koncerter og optrædener",
        "Memoreringsteknikker for omfattende værker"
      ]
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-serif font-bold mb-4">
              Din videre udvikling som pianist
            </h2>
            <p className="text-lg text-gray-600">
              Min undervisning for øvede pianister er struktureret til at hjælpe dig med at overvinde tekniske begrænsninger,
              forfine dit musikalske udtryk og udvikle din personlige stil.
            </p>
          </div>
          
          <div className="space-y-12">
            {journeySteps.map((step, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 rounded-full bg-piano-gold flex items-center justify-center text-white font-bold mr-4">
                    {index + 1}
                  </div>
                  <h3 className="text-xl font-serif font-semibold">{step.title}</h3>
                </div>
                <p className="text-gray-600 mb-4">{step.description}</p>
                <ul className="space-y-2">
                  {step.points.map((point, i) => (
                    <li key={i} className="flex items-start">
                      <Check className="w-5 h-5 text-piano-gold mr-2 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperiencedJourney;
